import { render } from "./SharesPaymentStructureComponent.vue?vue&type=template&id=27c509fb&scoped=true&ts=true"
import script from "./SharesPaymentStructureComponent.vue?vue&type=script&lang=ts"
export * from "./SharesPaymentStructureComponent.vue?vue&type=script&lang=ts"

import "./SharesPaymentStructureComponent.vue?vue&type=style&index=0&id=27c509fb&scoped=true&lang=css"

import exportComponent from "C:\\Users\\manya\\Documents\\Development\\Production\\Vue\\bbf-africa-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c509fb"]])

export default __exports__